export default "__VITE_ASSET__0c5803ac__"